module.exports = __webpack_public_path__ + "static/media/2 Wheeler.ca0e2eaf.svg";